import React, { useContext } from 'react';
import { RicosContext, usePluginExportsContext } from 'ricos-context';
import { Node_Type } from 'ricos-schema';
import { Loader, MediaItemErrorMsg } from 'wix-rich-content-ui-components';
import { getImageClickActionConfig } from '../viewer/get-image-click-action-config.js';
import { Image } from '../viewer/image.js';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';
import { EditorImageCaption } from './editor-image-caption.js';
import 'classnames';
import '../image-viewer.rtlignore-ef36fbd5.js';
import '../consts.js';
import '../icons/expand.js';
import '../viewer/image-container.js';
import '../dataHooks.js';
import '../viewer/use-custom-width-style.js';
import '../viewer/use-fallback-width-style.js';
import '../viewer/use-image-dimensions.js';
import '../viewer/use-image-social-attributes.js';
import 'lodash';
import '../InPluginInput.js';

var css_248z = "._3KwHh{align-items:center;display:flex;gap:20px}[dir] ._3KwHh{padding:0 20px}";
var styles = {"captionWrapper":"_3KwHh"};
styleInject(css_248z);

const EditorImage = ({ updateAttributes, node }) => {
  var _a, _b, _c, _d, _e, _f;
  const { t, isMobile } = useContext(RicosContext);
  const { loading, loadingPercentage, error, tempData } = node.attrs;
  const pluginExports = usePluginExportsContext();
  const onCaptionChange = (caption2) => {
    updateAttributes({ caption: caption2 });
  };
  const { src } = node.attrs.image || {};
  const shouldRender = !!tempData || (src == null ? void 0 : src.url) || (src == null ? void 0 : src.id);
  const ricosNode = {
    imageData: node.attrs,
    id: node.attrs.id,
    type: Node_Type.IMAGE,
    nodes: []
  };
  const imageClickActionConfig = getImageClickActionConfig({
    imageData: ricosNode.imageData
  });
  const AiCaptionTrigger = ((_b = (_a = pluginExports.aiIntegrations) == null ? void 0 : _a.image) == null ? void 0 : _b.captionTrigger) ? (_d = (_c = pluginExports == null ? void 0 : pluginExports.aiIntegrations) == null ? void 0 : _c.image) == null ? void 0 : _d.captionTrigger : null;
  const caption = /* @__PURE__ */ React.createElement(
    EditorImageCaption,
    {
      onCaptionChange,
      imageType: imageClickActionConfig.type,
      caption: (_f = (_e = ricosNode.imageData) == null ? void 0 : _e.caption) != null ? _f : ""
    }
  );
  return shouldRender ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Image,
    {
      isMobile,
      node: ricosNode,
      dataUrl: tempData,
      imageClickActionConfig: { type: "regular" },
      shouldLazyLoadImages: false,
      captionComponent: AiCaptionTrigger ? (
        // This is temporary solution until we make caption rich
        /* @__PURE__ */ React.createElement("div", { className: styles.captionWrapper }, /* @__PURE__ */ React.createElement(
          AiCaptionTrigger,
          {
            node: ricosNode,
            onCaptionChange
          }
        ), caption)
      ) : caption
    }
  ), loading && /* @__PURE__ */ React.createElement(Loader, { type: "medium", percent: loadingPercentage }), error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t })) : null;
};

export { EditorImage };
//# sourceMappingURL=component.js.map
